// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2K7AM","footer":"ModalUpdate_footer__2M0_x"};